import { render, staticRenderFns } from "./douweiMarketing.vue?vue&type=template&id=7ae0a9f2&scoped=true&"
import script from "./douweiMarketing.vue?vue&type=script&lang=js&"
export * from "./douweiMarketing.vue?vue&type=script&lang=js&"
import style0 from "./douweiMarketing.vue?vue&type=style&index=0&id=7ae0a9f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae0a9f2",
  null
  
)

export default component.exports